module.exports = __webpack_public_path__ + "img/empty-recent.4441cf0d.svg";